module.exports = __webpack_public_path__ + "img/pbia-concourse-c-expansion.1ab0e275.png";